import { MdlDialogReference, MdlSnackbarService } from '@angular-mdl/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken, SecurityContext } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GridDetails } from '../../../sample-tracking/tracking-overview/interfaces/grid';


export const SHIPMENT_CONFIRM_TOKEN = new InjectionToken('Shipment-Confirm-Token');

export class ConfirmDialogRequest {
    public message: string;
    public yesButtonText?: string;
    public noButtonText?: string;
    public isWarning?: boolean;
    public dropDownData?: { placeholder: string, listItem?: { key: number, value: string }[] };
    public gridDetails?: GridDetails;
    public title?: string;
    public reverseButtons?: boolean;
    public subHeaderText?: string;
    public isSampleTracking?: boolean;
    public warningBtnText?: string;
    public hideCloseIcon?: boolean;
    public isSMAlert?: boolean;
    public showReasonAreaByDefault?: boolean;
    public textareaPlaceholder?: string;
    public helpText?: string;
    public dropdownHeader?: string;
    public textareaHeader?: string;
    public isAlternateContainer?: boolean;
    public displayRequired?: boolean;
    public textMaxLength?: number;
    public isKitUpdateWarning?: boolean;
}

@Component({
    selector: 'confirm-dialog',
    template: require('./confirm-dialog.component.html'),
    styles: [require('./confirm-dialog.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConfirmDialogComponent {

    public confirmDialogRequest = new ConfirmDialogRequest();
    public confirmForm: FormGroup;
    public selectedOption: { id: number, value: string };
    public dropdownErrorMsg = '';
    public textMaxLength = 200;
    public reasonErrorMsg = '';
    public textAreaPlaceholder = 'Please enter the reason.';

    constructor(
        private dialog: MdlDialogReference,
        private router: Router,
        private sanitizer: DomSanitizer,
        private mdlSnackbarService: MdlSnackbarService,
        @Inject(SHIPMENT_CONFIRM_TOKEN) private readonly messageRequest: ConfirmDialogRequest) {

        this.confirmDialogRequest = messageRequest;
        if (messageRequest.textMaxLength) {
            this.textMaxLength = messageRequest.textMaxLength;
        }
        this.confirmForm = new FormGroup({
            confirmOptions: new FormControl(''),
            reason: new FormControl(''),
        });
    }
    public get textareaPlaceholder() {
        return this.confirmDialogRequest.textareaPlaceholder ? this.confirmDialogRequest.textareaPlaceholder : this.textAreaPlaceholder; 
    }

    public onStay() {
        this.confirmDialogResponse();
    }

    public onCancel() {
        this.confirmDialogResponse(true);
    }

    public close() {
        this.confirmDialogResponse(true);
    }

    public onDropDownSelect(data: any) {
        this.selectedOption = data;
        this.dropdownErrorMsg = this.reasonErrorMsg = null;
    }

    public goToSiteCommunicationView(url = '') {
        this.confirmDialogResponse(true);
        if (!url.length) {
            return;
        }

        try {
            const urlTree = this.router.createUrlTree([url]);
            const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, this.router.serializeUrl(urlTree));
            if (!sanitizedUrl) {
                throw new Error('Invalid URL after sanitization');
            }
            window.open(sanitizedUrl, '_blank');
        } catch (error) {
            console.error('Error opening site communication URL:', error);
            // Show user-friendly error message
            this.mdlSnackbarService.showSnackbar({
                message: 'Unable to open site communication page. Please try again later.',
                timeout: 3000
            });
        }
    }

    private confirmDialogResponse(isCancelled = false) {
        this.dropdownErrorMsg = this.reasonErrorMsg = null;
        if (!isCancelled && this.confirmDialogRequest.dropDownData) {
            if (!this.confirmForm.value.confirmOptions) {
                this.dropdownErrorMsg = 'Please select option.';
                return;
            }

            if ((this.confirmForm.value.confirmOptions === 'Other' && !this.confirmForm.value.reason) ||
                (this.confirmDialogRequest.showReasonAreaByDefault && !this.confirmForm.value.reason)) {
                this.reasonErrorMsg = 'Please enter reason.';
                return;
            }
        }

        return this.dialog.hide({
            isCancelled,
            selectedOption: {
                ...this.confirmForm.value,
                ...this.selectedOption
            }
        });
    }
}